import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const productService = {
  getProducts: async (token) => {
    const res = await axios.get(`${API_URL}/api/admin/products`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data || res.data; // Support both {data: [...]} and [...] formats
  },
  addProduct: async (token, product) => {
    const res = await axios.post(`${API_URL}/api/admin/products`, product, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  updateProduct: async (token, productId, updates) => {
    const res = await axios.put(`${API_URL}/api/admin/products/${productId}`, updates, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  deleteProduct: async (token, productId) => {
    await axios.delete(`${API_URL}/api/admin/products/${productId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default productService; 